import React from 'react';
import BannerWrapper from '../../BannerWrapper';

class NewTitle extends React.Component {
  render() {
    const pagedetails = this.props.pagedetails;
    const title = pagedetails.title;
    if (title === undefined) {
      return null;
    }

    return (
      <div className="com-heading">
        {pagedetails.title ? (
          <div className="heading">
            <span>{pagedetails.title}</span>
            <span className="heading-subtxt">{pagedetails.subText}</span>
          </div>
        ) : (
          ''
        )}
        {pagedetails.viewAllUrlLink ? (
          <div className="viewall">
            <a
              href={pagedetails.viewAllUrlLink}
              data-ga-event-category="Page Interaction"
              data-ga-event-action={`${pagedetails.title}/ViewAll`}
              data-ga-event-label={pagedetails.viewAllUrlLink}
            >
              {pagedetails.viewAllName}
            </a>
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }
}

export default BannerWrapper(NewTitle);
